import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { FOCUS_COMMAND, COMMAND_PRIORITY_EDITOR, EditorState, LexicalEditor, $setSelection } from 'lexical';

type OnFocusPluginProps = {
  onFocus?: (event: FocusEvent, editorState: EditorState, editor: LexicalEditor) => void;
};

export function OnFocusPlugin({ onFocus }: OnFocusPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      FOCUS_COMMAND,
      (event) => {
        onFocus?.(event, editor.getEditorState(), editor);
        editor.focus();
        editor.update(() => {
          $setSelection(null);
        });
        return false;
      },
      COMMAND_PRIORITY_EDITOR,
    );
  }, [editor, onFocus]);

  return null;
}
